<lh-shared-ui-spinner *ngIf="isLoading"></lh-shared-ui-spinner>

<div class="info-header">
  <div class="container-fluid lh-container-fluid-sm">
    <div class="flex">
      <h1 *ngIf="!error" class="heading-5">{{ 'MY_BOOKINGS' | translate }}</h1>

      <h1 class="heading-5" *ngIf="error">{{ 'NO_BOOKING_FOUND' | translate }}</h1>
      <div *ngIf="errorMsg">{{ errorMsg }}</div>

      <div *ngIf="bookings" class="filter">
        <div class="btn-group">
          <button
            id="showActiveBookings"
            (click)="showActiveBookings()"
            class="btn btn-primary"
            [class.active]="activeTab === 'active'"
          >
            {{ 'BOOKINGS_FILTER_ACTIVE' | translate }}
          </button>
          <button
            id="showCompletedBookings"
            (click)="showCompletedBookings()"
            class="btn btn-primary"
            [class.active]="activeTab === 'completed'"
          >
            {{ 'BOOKINGS_FILTER_COMPLETED' | translate }}
          </button>
          <button
            id="showCanceledBookings"
            (click)="showCanceledBookings()"
            class="btn btn-primary"
            [class.active]="activeTab === 'canceled'"
          >
            {{ 'BOOKINGS_FILTER_CANCELED' | translate }}
          </button>
          <button
            id="showAllBookings"
            (click)="showAllBookings()"
            class="btn btn-primary"
            [class.active]="activeTab === 'all'"
          >
            {{ 'BOOKINGS_FILTER_ALL' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container-fluid lh-container-fluid-sm">
  <div *ngIf="bookings">
    <div class="row" *ngIf="isShopOwner">
      <div class="form-group text-center">
        {{ 'LOOKING_FOR_SHOP_TRANSACTIONS' | translate }} {{ 'GO_TO' | translate }}
        <a id="goToShopManager" routerLink="/storage-manager" class="href">{{ 'SHOP_MANAGER' | translate }}</a>
      </div>
    </div>

    <div *ngIf="visibleBookings.length === 0">
      <h6 *ngIf="activeTab === 'active'">{{ 'NO_ACTIVE_BOOKINGS' | translate }}</h6>
      <h6 *ngIf="activeTab === 'completed'">{{ 'NO_COMPLETED_BOOKINGS' | translate }}</h6>
      <h6 *ngIf="activeTab === 'canceled'">{{ 'NO_CANCELED_BOOKINGS' | translate }}</h6>
      <h6 *ngIf="activeTab === 'all'">{{ 'NO_BOOKINGS' | translate }}</h6>
    </div>

    <!-- List of bookings grouped by date -->
    <lh-grouped-list
      [data]="groupedBookings"
      (itemSelected)="navigateToBooking($event.value)"
      *ngIf="isModernBookingListEnabled"
    ></lh-grouped-list>

    <ul class="list-group" *ngIf="!isModernBookingListEnabled">
      <a
        [id]="'goToBooking_' + booking._id"
        *ngFor="let booking of visibleBookings"
        class="list-group-item href"
        (click)="navigateToBooking(booking)"
      >
        <div class="media">
          <div class="media-body">
            <h4 class="media-heading">{{ booking.shopName }}</h4>
            {{ booking.address.street }}, {{ booking.address.city }}
          </div>
          <div class="media-right">
            <div *ngIf="!booking.period.checkIn">{{ booking.period.from | lhMoment: 'L' : booking.timezone }}</div>
            <div *ngIf="booking.period.checkIn">{{ booking.period.checkIn | lhMoment: 'L' : booking.timezone }}</div>
            <div>{{ booking.status | translate }}</div>
            <div>{{ booking | booking: 'summary' : false }}</div>
          </div>
        </div>
      </a>
    </ul>
  </div>
</div>
